var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "control-cabinet", class: { "is-valid": _vm.value } },
    [
      _vm.inputLabel
        ? _c(_vm.labelComponent, {
            tag: "component",
            staticClass: "control-cabinet__label",
            attrs: {
              "input-label": _vm.inputLabel,
              "is-required": _vm.required,
              for: _vm.id
            }
          })
        : _vm._e(),
      _c(
        _vm.element,
        _vm._g(
          _vm._b(
            {
              ref: "input",
              tag: "component",
              staticClass: "control-cabinet__element",
              attrs: { type: _vm.type, id: _vm.id },
              domProps: { checked: _vm.checked, value: _vm.value },
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            },
            "component",
            _vm.$attrs,
            false
          ),
          _vm.listeners
        )
      ),
      _vm.searchBttns
        ? _c("div", {
            staticClass: "control-cabinet__bttn-search pointer",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.searchEvent()
              }
            }
          })
        : _vm._e(),
      _vm.type == "password"
        ? _c("div", {
            staticClass: "control-cabinet__loopa pointer",
            class: _vm.loopClass,
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.changeType()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93db4482", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93db4482","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Controls/ControlDescriptor.vue
// module id = 889
// module chunks = 0